import { Alert, Avatar, Button, Card, Col, DatePicker, Descriptions, Divider, Form, Input, List, Modal, Row, Select, Spin, Statistic, Steps, Table, Timeline, Tooltip, Upload, message, Tag } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    UserOutlined,
    UploadOutlined,
    UnorderedListOutlined,
    CheckCircleOutlined,
    StopOutlined,
    SafetyCertificateOutlined
} from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import { exportToExcel } from './export/ExportEmployeeExcel';
import moment from 'moment';
import dayjs from 'dayjs';
import Paragraph from 'antd/es/typography/Paragraph';
import { FilterOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { downloadEmployeeImportTemplate, validateEmployeeImportFile } from './importEmployeeExcel';

const { Option } = Select;


function Employee() {
    const token = useSelector((state) => state.user.token);
    const myUser = useSelector((state) => state.user.user);
    const myMenu = useSelector((state) => state.user.menu);
    const [isResignModalOpen, setIsResignModalOpen] = useState(false);
    //DATA
    const [data, setData] = useState([]);
    const [userRole, setUserRole] = useState([]);
    const [level, setLevel] = useState([]);
    const [area, setArea] = useState([]);
    const [position, setPosition] = useState([]);
    const [division, setDivison] = useState([]);
    const [employeeStatus, setEmployeeStatus] = useState([]);
    const [user, setUser] = useState([]);
    const [schedule, setSchedule] = useState([]);
    const [fileList, setFileList] = useState([]);

    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [isModalExport, setIsModalExport] = useState(false);
    const [isModalUpload, setIsModalUpload] = useState(false);
    const [isModalDetail, setIsModalDetail] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [search, setSearch] = useState('');
    const [filterStatus, setFilterStatus] = useState();
    const [filterStatusExport, setFilterStatusExport] = useState('');
    const [resignDate, setResignDate] = useState(null);
    const [birthDateStr, setBirthDateStr] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [joinDate, setJoinDate] = useState(null);
    const [subordinates, setSubordinates] = useState([]);
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'users_id',
        }
    });
    const [form] = Form.useForm();
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [accessRole, setAccessRole] = useState(false);
    const [totalEmployee, setTotalEmployee] = useState(null);
    const [reasonResign, setReasonResign] = useState(null);
    const [approvalName, setApprovalName] = useState(null);

    const [filterDivision, setFilterDivision] = useState(null);
    const [filterArea, setFilterArea] = useState(null);
    const [filterPosition, setFilterPosition] = useState(null);
    const [filterLevel, setFilterLevel] = useState(null);
    const [isActivationModalOpen, setIsActivationModalOpen] = useState(false);
    const [activationData, setActivationData] = useState(null);
    const [activationReason, setActivationReason] = useState('');
    const [currentStep, setCurrentStep] = useState(0);
    const [roleModalOpen, setRoleModalOpen] = useState(false);
    const [roleTarget, setRoleTarget] = useState(null);
    const [quickRoleId, setQuickRoleId] = useState(null);
    const [roleSaving, setRoleSaving] = useState(false);

    // //Parameter 6 11 
    const titlePage = 'Employee';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Kode',
            dataIndex: 'users_code',
            key: "users_code",
            sorter: true
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            sorter: true
        },
        {
            title: 'Position',
            dataIndex: 'position',
            key: "position",
            render: (id, record) => {
                if (record.position !== null)
                    return record.position.name;
                else
                    return null;
            }
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: "role",
            render: (id, record) => {
                if (record.userrole !== null)
                    return record.userrole.name;
                else
                    return null;
            }
        },
        {
            title: 'Active Status',
            dataIndex: 'active_status',
            key: 'active_status',
            render: (_, record) => {
                const active = isEmployeeActive(record);

                return active ? (
                    <Tag color="green">Active</Tag>
                ) : (
                    <Tag color="red">Inactive</Tag>
                );
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                const active = isEmployeeActive(record);

                return (
                    <>

                        {filterStatus !== 'deleted' && (
                            <Tooltip title={active ? "Deactivate User" : "Activate User"}>
                                <Button
                                    type="primary"
                                    danger={active}
                                    style={{
                                        marginRight: 10,
                                        background: active ? undefined : "#003D79",
                                        borderColor: active ? undefined : "#003D79",
                                    }}
                                    onClick={() => openActivationModal(record)}
                                    icon={
                                        active
                                            ? <StopOutlined />
                                            : <CheckCircleOutlined />
                                    }
                                />
                            </Tooltip>
                        )}

                        <Tooltip title="Detail">
                            <Button type="default" style={{ marginRight: 10 }} onClick={() => openModal('detail', record)}>
                                <UnorderedListOutlined />
                            </Button>
                        </Tooltip>

                        {filterStatus !== 'deleted' && accessRole && (
                            <Tooltip title="Change User Role">
                                <Button
                                    type="default"
                                    style={{ marginRight: 10 }}
                                    icon={<SafetyCertificateOutlined />}
                                    onClick={() => {
                                        setRoleTarget(record);
                                        setQuickRoleId(record.user_role_id || record.userrole?.user_role_id || null);
                                        setRoleModalOpen(true);
                                    }}
                                />
                            </Tooltip>
                        )}

                        {filterStatus !== 'deleted' &&
                            <Tooltip title="Update">
                                <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                                    <EditOutlined />
                                </Button>
                            </Tooltip>}


                        {filterStatus !== 'deleted' &&
                            <Tooltip title="Delete">
                                <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                                    <DeleteOutlined />
                                </Button>
                            </Tooltip>}
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        let role = { role_menu: [] };
        try { role = JSON.parse(myMenu || '{}') || role; } catch (_) { role = { role_menu: [] }; }
        const menu6 = (role.role_menu || []).find(menu => Number(menu.menu_id) === 6);
        const hasSubmenu11 = !!menu6?.role_submenu?.some(sub => Number(sub.submenu_id) === 11);
        setAccessRole(hasSubmenu11);

        var statusUser = filterStatus;
        if (statusUser === 'resigned') {
            statusUser = '&status=resign';
        } else if (statusUser === 'end') {
            statusUser = '&status=end';
        } else if (statusUser === 'active') {
            statusUser = '&status=active';
        } else if (statusUser === 'deleted') {
            statusUser = '&status=deleted';
        }
        var order = page.sorter !== undefined && page.sorter.order ? page.sorter.order === "ascend" ? 'asc' : 'desc' : 'desc';
        var columnKey = page.sorter !== undefined && page.sorter.columnKey ? page.sorter.columnKey : 'users_id';
        let params = '';

        if (filterDivision) params += `&divisionId=${filterDivision}`;
        if (filterArea) params += `&areaId=${filterArea}`;
        if (filterPosition) params += `&positionId=${filterPosition}`;
        if (filterLevel) params += `&levelDetailId=${filterLevel}`;
        if (filterStatus) params += `&status=${filterStatus}`;
        getApi(
            'GET',
            `/users?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}${statusUser}${params}`,
            'users'
        );

        if (totalEmployee === null) {
            getApi('GET', '/totalusers', 'totaluser');
        }
        if (userRole.length === 0) {
            getApi('GET', '/userrole?nopage=true', 'userrole');
        }
        if (employeeStatus.length === 0) {
            getApi('GET', '/employee-status?nopage=true', 'employeeStatus');
        }
        if (level.length === 0) {
            getApi('GET', '/leveldetail?nopage=true', 'level');
        }
        if (position.length === 0) {
            getApi('GET', '/position?nopage=true', 'position');
        }
        if (division.length === 0) {
            getApi('GET', '/division?nopage=true', 'division');
        }
        if (area.length === 0) {
            getApi('GET', '/area?nopage=true', 'area');
        }
        if (user.length === 0) {
            getApi('GET', '/users?nopage=true', 'user');
        }
        if (schedule.length === 0) {
            getApi('GET', '/schedule?nopage=true', 'schedule');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlert, filterStatus, myMenu]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                switch (type) {
                    case 'parent':
                        setSubordinates(res.data.subordinates);
                        setLoading(false);
                        break;
                    case 'totaluser':
                        setTotalEmployee(res.data);
                        setLoading(false);
                        break;
                    case 'users':
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data
                            }
                        });
                        setLoading(false);
                        break;
                    case 'userrole':
                        var u = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item = res.data.data[i];
                            u.push({
                                value: item.user_role_id,
                                label: item.name
                            });
                        }
                        setUserRole(u);
                        break;
                    case 'level':
                        var level = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item1 = res.data.data[i];
                            level.push({
                                value: item1.level_detail_id,
                                label: item1.name
                            });
                        }
                        setLevel(level);
                        break;
                    case 'employeeStatus':
                        var employeeStatuss = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item1 = res.data.data[i];
                            employeeStatuss.push({
                                value: item1.employee_status_id,
                                label: item1.name
                            });
                        }
                        setEmployeeStatus(employeeStatuss);
                        break;
                    case 'position':
                        var position = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item2 = res.data.data[i];
                            position.push({
                                value: item2.position_id,
                                label: item2.name
                            });
                        }
                        setPosition(position);
                        break;
                    case 'division':
                        var division = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item3 = res.data.data[i];
                            division.push({
                                value: item3.division_id,
                                label: item3.name
                            });
                        }
                        setDivison(division);
                        break;
                    case 'area':
                        var area = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item4 = res.data.data[i];
                            area.push({
                                value: item4.area_id,
                                label: item4.name
                            });
                        }
                        setArea(area);
                        break;
                    case 'user':
                        var user = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item5 = res.data.data[i];
                            user.push({
                                value: item5.users_id,
                                label: item5.name
                            });
                        }
                        setUser(user);
                        break;
                    case 'schedule':
                        var schedule = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            var item7 = res.data.data[i];
                            schedule.push({
                                value: item7.schedule_id,
                                label: item7.schedule_name
                            });
                        }
                        setSchedule(schedule);
                        break;
                    case 'userall':
                        exportToExcel({
                            data: res.data.data,
                            employeeStatus: employeeStatus,
                        });
                        setIsModalExport(false);
                        setLoading(false);
                        break;

                    default:
                        break;
                }
            } else {
                setLoading(false);
                console.log(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
        })
    }

    const saveQuickRole = async () => {
        if (!roleTarget?.users_id || !quickRoleId) {
            modalError('Please select a role');
            return;
        }
        setRoleSaving(true);
        try {
            const res = await apiCall({
                method: 'PATCH',
                url: `/users/${roleTarget.users_id}/role`,
                data: {
                    data: { user_role_id: quickRoleId },
                    headers: { Authorization: 'Bearer ' + token }
                }
            });
            if (res?.status === 'success') {
                message.success(res.message || 'User role updated');
                setRoleModalOpen(false);
                setRoleTarget(null);
                setQuickRoleId(null);
                setIsAlert((prev) => !prev);
            } else {
                modalError(res?.message || 'Failed to update user role');
            }
        } catch (e) {
            modalError(e?.message || 'Failed to update user role');
        } finally {
            setRoleSaving(false);
        }
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', '/users/' + v.users_id, null),
        });
    }

    const formatDate = (date) => {
        if (!date) return '-';
        return new Date(date).toLocaleDateString('id-ID', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        });
    };

    const isPermanentEmployeeStatus = (statusValue) => {
        return String(statusValue) === '2';
    };

    const handleEmployeeStatusChange = (value) => {
        // Hanya Permanent (employee_status_id = 2) yang tidak memiliki end date.
        if (isPermanentEmployeeStatus(value)) {
            form.setFieldValue('end_date', null);
            setEndDate(null);
        }
    };

    const openModal = async (type, data) => {
        if (type === 'detail') {
            setSubordinates([])
            setdataModal(data);
            getApi('GET', '/userparent/' + data.users_id, 'parent');
            setIsModalDetail(true);
        } else if (type === 'edit') {
            setdataModal(data);
            setBirthDateStr(data.birthdate ? data.birthdate : null)
            setJoinDate(data.join_date ? data.join_date : null)
            const normalizedEmployeeStatus = normalizeEmployeeStatus(
                data.employee_status ?? data.employee_status_id
            );
            const employeeHasEndDate = !isPermanentEmployeeStatus(normalizedEmployeeStatus);
            setEndDate(employeeHasEndDate && data.end_date ? data.end_date : null)
            setApprovalName(data.approval_name);
            form.setFieldsValue({
                users_code: data.users_code,
                nik: data.nik,
                email: data.email,
                phone: data.phone,
                username: data.username,
                user_role_id: data.user_role_id > 0 ? data.user_role_id : null,
                name: data.name,
                area_id: data.area_id > 0 ? data.area_id : null,
                position_id: data.position_id > 0 ? data.position_id : null,
                level_detail_id: data.level_detail_id > 0 ? data.level_detail_id : null,
                division_id: data.division_id > 0 ? data.division_id : null,
                schedule_id: data.schedule_id > 0 ? data.schedule_id : null,
                employee_status: normalizedEmployeeStatus,
                users_parent_id: data.users_parent_id > 0 ? data.users_parent_id : null,
                gender: data.gender,
                religion: data.religion,
                marital_status: data.marital_status,
                birthdate: data.birthdate ? dayjs(data.birthdate) : null,
                join_date: data.join_date ? dayjs(data.join_date) : null,
                end_date: employeeHasEndDate && data.end_date ? dayjs(data.end_date) : null,
                resign_date: data.resign_date ? dayjs(data.resign_date) : null,
                address: data.address,
                address_now: data.address_now,
                ptkp_status: data.ptkp_status,
                bank_name: data.bank_name,
                bank_account: data.bank_account,
                bank_account_name: data.bank_account_name,

                npwp: data.npwp,
                bloody_type: data.bloody_type,
                postal_code: data.postal_code,
                branch_name: data.branch_name,
                class: data.class,
                grade: data.grade,
                education_history: Array.isArray(data.education_history)
                    ? data.education_history.map((item) => ({
                        education_level: item.education_level || undefined,
                        institution_name: item.institution_name || '',
                        major: item.major || '',
                        start_year: item.start_year || undefined,
                        end_year: item.end_year || undefined,
                        gpa: item.gpa || '',
                        description: item.description || '',
                    }))
                    : [],
            })
            setCurrentStep(0);
            setIsModal(true);
        } else {
            setdataModal(null);
            form.resetFields();
            form.setFieldsValue({ education_history: [] });
            setCurrentStep(0);
            setIsModal(true);
        }
    }

    const normalizeEmployeeStatus = (status) => {
        if (!status) return null;

        // cek apakah pure angka
        const isNumber = /^\d+$/.test(status);

        if (isNumber) {
            return Number(status); // jadi number
        }

        // kalau string → cari di options
        const found = employeeStatus.find(
            (item) => item.label.toLowerCase() === String(status).toLowerCase()
        );

        return found?.value ?? null;
    };

    const formatFormDate = (value) => {
        if (!value) return null;

        const parsedDate = dayjs(value);

        return parsedDate.isValid()
            ? parsedDate.format('YYYY-MM-DD')
            : null;
    };

    const onFinish = () => {
        const values = form.getFieldsValue(true);

        const payload = {
            ...values,
            birthdate: formatFormDate(values.birthdate),
            join_date: formatFormDate(values.join_date),
            end_date: formatFormDate(values.end_date),
            resign_date: formatFormDate(values.resign_date),
            approval_name: approvalName,
            education_history: (values.education_history || []).map((item) => ({
                education_level: item.education_level || '',
                institution_name: (item.institution_name || '').trim(),
                major: (item.major || '').trim(),
                start_year: item.start_year ? Number(item.start_year) : 0,
                end_year: item.end_year ? Number(item.end_year) : 0,
                gpa: (item.gpa || '').trim(),
                description: (item.description || '').trim(),
            })),
        };

        if (isPermanentEmployeeStatus(values.employee_status)) {
            payload.end_date = null;
        }

        const formData = new FormData();

        Object.entries(payload).forEach(([key, value]) => {
            if (key === 'education_history') {
                formData.append(
                    key,
                    JSON.stringify(Array.isArray(value) ? value : [])
                );
                return;
            }

            formData.append(
                key,
                value === undefined || value === null ? '' : value
            );
        });

        if (dataModal) {
            postApi('PUT', `/users/${dataModal.users_id}`, formData);
        } else {
            postApi('POST', '/users', formData);
        }
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModalDetail(false)
        setIsModal(false);
        setCurrentStep(0);
        setIsModalUpload(false);
        form.resetFields();
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    const props = {
        onRemove: file => {
            setFileList(prev => prev.filter(item => item.uid !== file.uid));
        },
        beforeUpload: file => {
            setFileList([file]);
            return false;
        },
        fileList,
    };

    const postUpload = (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                message.success('File uploaded successfully!');
                setFileList([]);
                closeModal();
                setIsModalUpload(false)
            } else {
                setLoading(false);
                setIsModalUpload(false)
                modalError(res.message);
            }
        }).catch((e) => {
            setIsModalUpload(false)
            setLoading(false);
        })
    }

    const handleUpload = async () => {
        if (!fileList[0]) {
            message.warning('Pilih file Excel terlebih dahulu.');
            return;
        }

        try {
            setLoading(true);
            await validateEmployeeImportFile(fileList[0]);
            const formData = new FormData();
            formData.append('file', fileList[0]);
            postUpload('POST', '/upload/employee', formData);
        } catch (error) {
            setLoading(false);
            modalError(error.message);
        }
    };

    const handleExport = () => {
        var statusUser = filterStatusExport;
        if (statusUser === 'resigned') {
            statusUser = '&status=resign';
        } else if (statusUser === 'end') {
            statusUser = '&status=end';
        } else if (statusUser === 'active') {
            statusUser = '&status=active';
        } else if (statusUser === 'all') {
            // statusUser = '&status=active';
            statusUser = ''
        }
        getApi('GET', '/users?nopage=true' + statusUser, 'userall');
    }

    const handleStatusChange = (value) => {
        setFilterStatus(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    const confirmResign = () => {
        if (!resignDate) {
            message.warning("Please select the resignation date first.");
            return;
        }

        handleResign(dataModal.users_id, resignDate.format('YYYY-MM-DD'));
        setIsResignModalOpen(false);
        setIsModalDetail(false);
        setResignDate(null);
    };

    const handleResign = () => {
        const formData = new FormData();
        var resign_date = resignDate.format('YYYY-MM-DD');
        formData.append('resign_date', resign_date);
        postApi('PUT', '/userresign/' + dataModal.users_id, formData);
    }

    const handleActivation = (id, action) => {
        Modal.confirm({
            title: action === 'activate'
                ? 'Activate Employee'
                : 'Deactivate Employee',

            content:
                action === 'activate'
                    ? 'Are you sure want activate this employee?'
                    : 'Are you sure want deactivate this employee?',

            okText: action === 'activate' ? 'Activate' : 'Deactivate',

            okButtonProps: {
                danger: action === 'deactivate'
            },

            onOk: async () => {
                setLoading(true);

                const dataReq = {
                    method: 'PUT',
                    url: '/activation/user/' + id,
                    data: {
                        data: {
                            action,
                            reason:
                                action === 'activate'
                                    ? 'User activated via admin panel'
                                    : 'User deactivated via admin panel'
                        },
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                };

                try {
                    const res = await apiCall(dataReq);

                    if (res.status === 'success') {
                        message.success(res.message);

                        closeModal();

                        getApi(
                            'GET',
                            `/users?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}`,
                            'users'
                        );
                    } else {
                        modalError(res.message);
                    }
                } catch (e) {
                    modalError('Failed update activation');
                }

                setLoading(false);
            }
        });
    };

    const calculateDuration = (startDate, endDate) => {
        if (!startDate) return "-";

        const start = moment(startDate).startOf("day");
        const today = moment().startOf("day");
        const end = endDate ? moment(endDate).startOf("day") : null;

        // kalau startDate di masa depan
        if (start.isAfter(today)) {
            return "0 Years 0 Months";
        }

        // tentukan batas akhir durasi
        let endPoint;
        if (end) {
            // kalau endDate sudah lewat → sampai endDate
            if (end.isBefore(today)) {
                endPoint = end;
            } else {
                // kalau endDate di masa depan → hitung sampai hari ini
                endPoint = today;
            }
        } else {
            endPoint = today;
        }

        const years = endPoint.diff(start, "years");
        const months = endPoint.diff(start.clone().add(years, "years"), "months");

        return `${years} Years ${months} Months`;
    };

    const isEmployeeActive = (employee) => {
        if (!employee) return false;

        const today = moment().startOf("day");

        const resignDate = employee.resign_date
            ? moment(employee.resign_date).startOf("day")
            : null;

        const endDate = employee.end_date
            ? moment(employee.end_date).startOf("day")
            : null;

        if (resignDate && resignDate.isSameOrBefore(today)) {
            return false;
        }

        if (endDate && endDate.isSameOrBefore(today)) {
            return false;
        }

        return true;
    };

    const FilterPopup = () => (
        <div style={{ width: 250 }}>
            <strong>Filter Employee</strong>

            <Divider />

            <p>Status</p>
            <Select
                allowClear
                style={{ width: "100%" }}
                value={filterStatus}
                placeholder="Select status"
                onChange={setFilterStatus}
            >
                <Option value="">All</Option>
                <Option value="active">Active</Option>
                <Option value="resign">Resign</Option>
                <Option value="end">Contract End</Option>
                <Option value="deleted">Deleted</Option>
            </Select>

            <p style={{ marginTop: 12 }}>Division</p>
            <Select
                allowClear
                style={{ width: "100%" }}
                options={division}
                value={filterDivision}
                onChange={setFilterDivision}
                placeholder="Select division"
            />

            <p style={{ marginTop: 12 }}>Area</p>
            <Select
                allowClear
                style={{ width: "100%" }}
                options={area}
                value={filterArea}
                onChange={setFilterArea}
                placeholder="Select area"
            />

            <p style={{ marginTop: 12 }}>Position</p>
            <Select
                allowClear
                style={{ width: "100%" }}
                options={position}
                value={filterPosition}
                onChange={setFilterPosition}
                placeholder="Select position"
            />

            <p style={{ marginTop: 12 }}>Level</p>
            <Select
                allowClear
                style={{ width: "100%" }}
                options={level}
                value={filterLevel}
                onChange={setFilterLevel}
                placeholder="Select level"
            />

            <Button
                type="primary"
                block
                style={{ marginTop: 16 }}
                onClick={() => {
                    setPage({
                        pagination: { current: 1, pageSize: 10 }
                    });
                }}
            >
                Apply Filter
            </Button>

            <Button
                block
                style={{ marginTop: 8 }}
                onClick={() => {
                    setFilterStatus(null);
                    setFilterDivision(null);
                    setFilterArea(null);
                    setFilterPosition(null);
                    setFilterLevel(null);
                    setPage({
                        pagination: { current: 1, pageSize: 10 }
                    });
                }}
            >
                Reset Filter
            </Button>
        </div>
    );
    const openActivationModal = (record) => {
        setActivationData(record);
        setActivationReason('');
        setIsActivationModalOpen(true);
    };

    const submitActivation = async () => {
        if (!activationData) return;

        const active = isEmployeeActive(activationData);
        const action = active ? "deactivate" : "activate";

        if (!activationReason) {
            message.warning("Please input reason.");
            return;
        }

        setLoading(true);

        const dataReq = {
            method: 'PUT',
            url: '/activation/user/' + activationData.users_id,
            data: {
                data: {
                    action,
                    reason: activationReason
                },
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };

        try {
            const res = await apiCall(dataReq);

            if (res.status === 'success') {
                message.success(res.message);
                setIsActivationModalOpen(false);
                setActivationData(null);
                setActivationReason('');
                setIsAlert(true);
                setTextAlert(res.message);
            } else {
                modalError(res.message);
            }
        } catch (e) {
            modalError('Failed update activation');
        }

        setLoading(false);
    };
    const employeeStatuss = Form.useWatch('employee_status', form);
    const showEmployeeEndDate = !isPermanentEmployeeStatus(employeeStatuss);
    const employeeFormSteps = [
        {
            title: 'Account',
            fields: ['user_role_id', 'users_code', 'name', 'nik', 'username', 'email', 'phone']
        },
        {
            title: 'Employment',
            fields: [
                'position_id',
                'level_detail_id',
                'division_id',
                'area_id',
                'users_parent_id',
                'schedule_id',
                'employee_status',
                'join_date',
                'end_date',
                'resign_date',
                'branch_name',
                'grade',
                'class'
            ]
        },
        {
            title: 'Personal',
            fields: [
                'gender',
                'religion',
                'marital_status',
                'birthdate',
                'bloody_type',
                'address',
                'address_now',
                'postal_code'
            ]
        },
        {
            title: 'Education',
            fields: ['education_history']
        },
        {
            title: 'Tax & Bank',
            fields: ['ptkp_status', 'npwp', 'bank_name', 'bank_account', 'bank_account_name']
        }
    ];

    const nextEmployeeStep = async () => {
        const visibleFields = employeeFormSteps[currentStep].fields.filter((field) => {
            // user_role_id tidak perlu divalidasi apabila field tidak ditampilkan
            if (field === 'user_role_id' && !accessRole) {
                return false;
            }

            return true;
        });

        try {
            await form.validateFields(visibleFields);

            setCurrentStep((prevStep) =>
                Math.min(prevStep + 1, employeeFormSteps.length - 1)
            );
        } catch (error) {
            console.log('Step validation failed:', error.errorFields);

            const firstErrorField = error.errorFields?.[0]?.name;

            if (firstErrorField) {
                form.scrollToField(firstErrorField, {
                    behavior: 'smooth',
                    block: 'center',
                });
            }

            message.warning('Please complete the required fields.');
        }
    };

    const previousEmployeeStep = () => {
        setCurrentStep((step) => Math.max(step - 1, 0));
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}

            <h2 style={{ marginBottom: 8 }}>Employee List</h2>
            <Divider />

            {totalEmployee && (
                <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                    <Col xs={24} sm={12} md={8}>
                        <Card>
                            <Statistic title="Active Employee" value={totalEmployee.active} valueStyle={{ color: '#3f8600' }} />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                        <Card>
                            <Statistic title="Employee Resigns" value={totalEmployee.resign} valueStyle={{ color: '#cf1322' }} />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                        <Card>
                            <Statistic title="Contract Ends" value={totalEmployee.contract} valueStyle={{ color: '#d48806' }} />
                        </Card>
                    </Col>
                </Row>
            )}

            <Card style={{ marginBottom: 24 }}>
                <Row gutter={[16, 16]} align="middle" justify="space-between">
                    <Col xs={24} md={16}>
                        <Row gutter={[8, 8]}>
                            <Col>
                                <Button type="primary" onClick={() => setIsModalUpload(true)}>
                                    <PlusOutlined />
                                    <span style={{ marginLeft: 5 }}>Import Excel</span>
                                </Button>
                            </Col>
                            <Col>
                                <Button onClick={() => setIsModalExport(true)}>
                                    Export Excel
                                </Button>
                            </Col>
                            {/* <Col>
                                <Select
                                    allowClear
                                    style={{ width: 140 }}
                                    onChange={handleStatusChange}
                                    value={filterStatus}
                                    placeholder="Filter Status"
                                >
                                    <Option value="">All</Option>
                                    <Option value="active">Active</Option>
                                    <Option value="resigned">Resign</Option>
                                    <Option value="end">Contract End</Option>
                                    <Option value="deleted">Deleted</Option>
                                </Select>
                            </Col> */}
                            <Col>
                                <Popover
                                    content={<FilterPopup />}
                                    trigger="click"
                                    placement="bottomLeft"
                                >
                                    <Button icon={<FilterOutlined />} />
                                </Popover>
                            </Col>

                            <Col flex="auto">
                                <Search
                                    placeholder="Search employee"
                                    allowClear
                                    enterButton="Search"
                                    size="middle"
                                    onSearch={searchData}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} md="auto" style={{ textAlign: 'right' }}>
                        <Button type="primary" onClick={() => openModal('add', null)}>
                            <PlusOutlined />
                            <span style={{ marginLeft: 5 }}>Add Employee</span>
                        </Button>
                    </Col>
                </Row>
            </Card>

            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Konfirmasi Export Data Karyawan"
                open={isModalExport}
                onOk={handleExport}
                onCancel={() => setIsModalExport(false)}
                okText="Ya, Lanjutkan Export"
                cancelText="Batalkan"
            >
                <Alert
                    type="warning"
                    showIcon
                    message="Pastikan Anda telah memfilter status karyawan dengan benar."
                    description="Data yang diekspor akan mencerminkan kondisi terkini berdasarkan status karyawan yang dipilih."
                    style={{ marginBottom: 16 }}
                />

                <Paragraph strong style={{ marginBottom: 8 }}>
                    Pilih status karyawan yang ingin Anda ekspor:
                </Paragraph>

                <Select
                    placeholder="Pilih Status"
                    allowClear
                    style={{ width: '100%' }}
                    onChange={(ev) => setFilterStatusExport(ev)}
                    value={filterStatusExport}
                >
                    <Option value="all">All</Option>
                    <Option value="active">Active</Option>
                    <Option value="resigned">Resign</Option>
                    <Option value="end">Contract End</Option>
                </Select>
            </Modal>


            <Modal
                title={
                    <span>
                        <UploadOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                        Upload File Excel Karyawan (Talenta)
                    </span>
                }
                open={isModalUpload}
                onOk={handleUpload}
                onCancel={() => setIsModalUpload(false)}
                okText={loading ? <Spin size="small" /> : 'Upload Sekarang'}
                confirmLoading={loading}
                cancelText="Batalkan"
            >
                <Alert
                    message="Pastikan file Anda sesuai format"
                    description="File harus berformat .xlsx, hanya memiliki satu sheet, dan menggunakan template Employee yang sudah dilengkapi kolom pendidikan."
                    type="info"
                    showIcon
                    style={{ marginBottom: 16 }}
                />

                <Upload {...props} maxCount={1} disabled={loading}>
                    <Button
                        icon={<UploadOutlined />}
                        disabled={loading || fileList.length > 0}
                        style={{ width: '100%' }}
                    >
                        {loading ? 'Mengunggah...' : 'Pilih File Excel (.xlsx)'}
                    </Button>
                </Upload>

                <Button
                    type="link"
                    onClick={downloadEmployeeImportTemplate}
                    disabled={loading}
                    style={{ paddingLeft: 0, marginTop: 8 }}
                >
                    Download Template Import Employee
                </Button>

                <Paragraph type="secondary" style={{ marginTop: 12 }}>
                    Hanya satu file yang dapat diunggah. Pastikan file sudah final.
                </Paragraph>
            </Modal>

            <Modal
                title="Detail Employee"
                open={isModalDetail}
                onCancel={() => closeModal()}
                footer={[
                    <Button key="cancel" onClick={() => closeModal()}>
                        Cancel
                    </Button>,

                    dataModal && isEmployeeActive(dataModal) ? (
                        <Button
                            key="deactivate"
                            type="primary"
                            danger
                            onClick={() => handleActivation(dataModal.users_id, "deactivate")}
                        >
                            Deactivate
                        </Button>
                    ) : (
                        <Button
                            key="activate"
                            type="primary"
                            style={{ background: "#003D79" }}
                            onClick={() => handleActivation(dataModal.users_id, "activate")}
                        >
                            Activate
                        </Button>
                    )
                ]}
                width={900}
            >
                {dataModal && <>
                    <Row gutter={16} align="middle" style={{ marginBottom: 24 }}>
                        <Col>
                            <Avatar
                                size={96}
                                src={dataModal.image || null}
                                icon={!dataModal.image && <UserOutlined />}
                            />
                        </Col>
                        <Col>
                            <h2 style={{ margin: 0 }}>{dataModal.name}</h2>
                            <div>{dataModal.users_code} &middot; {dataModal.userrole?.name}</div>
                            <div>{dataModal.position?.name}</div>
                        </Col>
                    </Row>

                    <Divider orientation="left">Personal Information</Divider>
                    <Descriptions bordered column={2} size="small">
                        <Descriptions.Item label="NIK">{dataModal.nik}</Descriptions.Item>
                        <Descriptions.Item label="Username">{dataModal.username}</Descriptions.Item>
                        <Descriptions.Item label="Email">{dataModal.email}</Descriptions.Item>
                        <Descriptions.Item label="Phone">{dataModal.phone}</Descriptions.Item>
                        <Descriptions.Item label="Gender">{dataModal.gender}</Descriptions.Item>
                        <Descriptions.Item label="Religion">{dataModal.religion}</Descriptions.Item>
                        <Descriptions.Item label="Marital Status">{dataModal.marital_status}</Descriptions.Item>
                        <Descriptions.Item label="Date of birth">{formatDate(dataModal.birthdate)}</Descriptions.Item>
                        <Descriptions.Item label="Address (ID card)" span={2}>{dataModal.address}</Descriptions.Item>
                        <Descriptions.Item label="Current address" span={2}>{dataModal.address_now}</Descriptions.Item>
                    </Descriptions>

                    <Divider orientation="left">Job Information</Divider>
                    <Descriptions bordered column={2} size="small">
                        <Descriptions.Item label="Division">{dataModal.division?.name}</Descriptions.Item>
                        <Descriptions.Item label="Area">{dataModal.area?.name}</Descriptions.Item>
                        <Descriptions.Item label="Level">{dataModal.level_detail?.name}</Descriptions.Item>
                        <Descriptions.Item label="Status">
                            {
                                !isNaN(dataModal.employee_status)
                                    ? employeeStatus.find(
                                        item => String(item.value) === String(dataModal.employee_status)
                                    )?.label
                                    : dataModal.employee_status
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label="Date of entry">{formatDate(dataModal.join_date)}</Descriptions.Item>
                        {!isPermanentEmployeeStatus(dataModal.employee_status_id ?? dataModal.employee_status) && (
                            <Descriptions.Item label="End Date">{formatDate(dataModal.end_date)}</Descriptions.Item>
                        )}
                        <Descriptions.Item label="Direct supervisor">{dataModal.approval_name || '-'}</Descriptions.Item>
                        <Descriptions.Item label="Resignation Date">{formatDate(dataModal.resign_date)}</Descriptions.Item>
                        <Descriptions.Item label="Duration">
                            {calculateDuration(dataModal.join_date, dataModal.end_date || dataModal.resign_date)}
                        </Descriptions.Item>
                    </Descriptions>

                    <Divider orientation="left">Education History</Divider>
                    {Array.isArray(dataModal.education_history) && dataModal.education_history.length > 0 ? (
                        <Table
                            rowKey={(record, index) =>
                                record.user_education_history_id || `${record.institution_name}-${index}`
                            }
                            pagination={false}
                            size="small"
                            dataSource={dataModal.education_history}
                            columns={[
                                { title: 'Level', dataIndex: 'education_level', key: 'education_level' },
                                { title: 'Institution', dataIndex: 'institution_name', key: 'institution_name' },
                                { title: 'Major', dataIndex: 'major', key: 'major' },
                                {
                                    title: 'Period',
                                    key: 'period',
                                    render: (_, record) =>
                                        [record.start_year, record.end_year].filter(Boolean).join(' - ') || '-'
                                },
                                { title: 'GPA', dataIndex: 'gpa', key: 'gpa' },
                            ]}
                        />
                    ) : (
                        <p>No education history</p>
                    )}

                    <Divider orientation="left">Tax & Bank Information</Divider>
                    <Descriptions bordered column={2} size="small">
                        <Descriptions.Item label="NPWP">{dataModal.npwp}</Descriptions.Item>
                        <Descriptions.Item label="PTKP">{dataModal.ptkp_status}</Descriptions.Item>
                        <Descriptions.Item label="Bank Name">{dataModal.bank_name}</Descriptions.Item>
                        <Descriptions.Item label="No. Account">{dataModal.bank_account || '-'}</Descriptions.Item>
                        <Descriptions.Item label="On Account Name">{dataModal.bank_account_name}</Descriptions.Item>
                    </Descriptions>
                </>}
                <Divider orientation="left">History of the Department</Divider>
                {
                    dataModal && dataModal.position_history && dataModal.position_history.length > 0 ? (
                        <Timeline mode="left">
                            {dataModal.position_history.map((item, index) => (
                                <Timeline.Item
                                    key={index}
                                    label={moment(item.start_date).format('YYYY-MM-DD')}
                                    color={item.end_date ? 'blue' : 'green'}
                                >
                                    <strong>{item.position?.name || '-'}</strong> <br />
                                    {item.division?.name && <>Divisi: {item.division.name} <br /></>}
                                    {item.level_detail?.name && <>Level: {item.level_detail.name} <br /></>}
                                    {item.grade && <>Grade: {item.grade}, </>}
                                    {item.class && <>Class: {item.class}</>}
                                    <br />
                                    {item.notes && <em>{item.notes}</em>}
                                    <br />
                                    {item.end_date && <span style={{ fontSize: 12, color: '#888' }}>End: {moment(item.end_date).format('YYYY-MM-DD')}</span>}
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    ) : (
                        <p>There is no job history</p>
                    )
                }
                <Divider orientation="left">Subordinates</Divider>
                {
                    loading === false ?
                        subordinates && subordinates.length > 0 ? (
                            <List
                                itemLayout="horizontal"
                                dataSource={subordinates}
                                renderItem={(sub) => (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={
                                                <Avatar
                                                    src={sub.image || null}
                                                    icon={!sub.image && <UserOutlined />}
                                                />
                                            }
                                            title={<span>{sub.name}</span>}
                                            description={
                                                <>
                                                    <div>{sub.users_code}</div>
                                                    <div>{sub.position?.name || '-'}</div>
                                                    <div>{sub.division?.name || '-'}</div>
                                                </>
                                            }
                                        />
                                    </List.Item>
                                )}
                            />
                        ) : (
                            <p>No subordinates</p>
                        )
                        :
                        <Spin tip="Loading..." />
                }

            </Modal>

            <Modal
                title="Change User Role"
                open={roleModalOpen}
                okText="Save Role"
                confirmLoading={roleSaving}
                onOk={saveQuickRole}
                onCancel={() => {
                    if (roleSaving) return;
                    setRoleModalOpen(false);
                    setRoleTarget(null);
                    setQuickRoleId(null);
                }}
            >
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 16 }}
                    message="Security sensitive action"
                    description="This action only changes the user's access role. The change is logged and the user's menu will refresh automatically."
                />
                <Form layout="vertical">
                    <Form.Item label="Employee">
                        <Input value={roleTarget?.name || '-'} disabled />
                    </Form.Item>
                    <Form.Item label="User Role" required>
                        <Select
                            showSearch
                            optionFilterProp="label"
                            value={quickRoleId}
                            options={userRole}
                            placeholder="Select user role"
                            onChange={setQuickRoleId}
                        />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Resignation Confirmation"
                open={isResignModalOpen}
                onCancel={() => {
                    setIsResignModalOpen(false);
                    setResignDate(null);
                }}
                onOk={confirmResign}
                okText="Resign"
                okButtonProps={{ danger: true }}
            >
                <Form layout="vertical">
                    <Form.Item label="Resignation Date" required>
                        <DatePicker
                            value={resignDate}
                            onChange={(date) => setResignDate(date)}
                            format="YYYY-MM-DD"
                            style={{ width: '100%' }}
                            placeholder="Select a resignation date"
                        />
                    </Form.Item>

                    <Form.Item label="Reason for Resignation" required>
                        <Input.TextArea
                            value={reasonResign}
                            onChange={(e) => setReasonResign(e.target.value)}
                            rows={4}
                            placeholder="Provide a brief reason for the resignation"
                        />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title={dataModal ? "Edit Employee Data" : "Add Employee Data"}
                width={800}
                open={isModal}
                onCancel={() => closeModal()}
                footer={[
                    <Button key="cancel" onClick={() => closeModal()}>
                        Cancel
                    </Button>,
                    currentStep > 0 && (
                        <Button key="previous" onClick={previousEmployeeStep}>
                            Previous
                        </Button>
                    ),
                    currentStep < employeeFormSteps.length - 1 ? (
                        <Button key="next" type="primary" onClick={nextEmployeeStep}>
                            Next
                        </Button>
                    ) : (
                        <Button key="save" type="primary" loading={loading} onClick={() => form.submit()}>
                            Save
                        </Button>
                    )
                ]}
            >
                <Steps
                    current={currentStep}
                    items={employeeFormSteps.map((step) => ({ title: step.title }))}
                    responsive
                    style={{ marginBottom: 24 }}
                />

                <Form form={form} name="form_users" layout="vertical" onFinish={onFinish} preserve>
                    {currentStep === 0 && (
                        <Row gutter={16}>
                            {accessRole && (
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        name="user_role_id"
                                        label="Select Access Rights Position"
                                        rules={[{ required: true, message: 'The Access Rights position is vacant!' }]}
                                    >
                                        <Select options={userRole} placeholder="Select access rights position" />
                                    </Form.Item>
                                </Col>
                            )}

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="users_code"
                                    label="User Code"
                                    rules={[{ required: true, message: 'User Code is empty!' }]}
                                >
                                    <Input placeholder="Enter user code" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="name"
                                    label="Full Name"
                                    rules={[{ required: true, message: 'Full Name is empty!' }]}
                                >
                                    <Input placeholder="Enter full name" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="nik"
                                    label="NIK"
                                    rules={[{ required: true, message: 'Empty NIK!' }]}
                                >
                                    <Input placeholder="Enter NIK" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="username"
                                    label="Username"
                                    rules={[{ required: true, message: 'Empty Username!' }]}
                                >
                                    <Input placeholder="Enter username" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="email"
                                    label="E-mail"
                                    rules={[{ required: true, message: 'Empty E-mail!' }]}
                                >
                                    <Input placeholder="Enter email address" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="phone"
                                    label="Mobile phone number"
                                    rules={[{ required: true, message: 'Empty Mobile phone number!' }]}
                                >
                                    <Input type="number" placeholder="Enter mobile phone number" />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    {currentStep === 1 && (
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="position_id"
                                    label="Select Position"
                                    rules={[{ required: true, message: 'Empty Department!' }]}
                                >
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Choose position"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(a, b) =>
                                            (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())
                                        }
                                        options={position}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="level_detail_id" label="Select Level">
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Choose level"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(a, b) =>
                                            (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())
                                        }
                                        options={level}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="division_id" label="Select Division">
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Choose division"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(a, b) =>
                                            (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())
                                        }
                                        options={division}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="area_id" label="Select Area">
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Choose area"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(a, b) =>
                                            (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())
                                        }
                                        options={area}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="users_parent_id" label="Select Approval Line">
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Choose approval line"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(a, b) =>
                                            (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())
                                        }
                                        options={user}
                                        onChange={(value, option) => setApprovalName(option?.label || null)}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="schedule_id" label="Select Schedule">
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Choose schedule"
                                        optionFilterProp="children"
                                        options={schedule}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="employee_status" label="Employee Status">
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Choose employee status"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                        }
                                        filterSort={(a, b) =>
                                            (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())
                                        }
                                        options={employeeStatus}
                                        onChange={handleEmployeeStatusChange}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="join_date" label="Join Date">
                                    <DatePicker
                                        format="YYYY-MM-DD"
                                        style={{ width: '100%' }}
                                        placeholder="Select join date"
                                        onChange={(e, dateString) => setJoinDate(dateString)}
                                    />
                                </Form.Item>
                            </Col>

                            {showEmployeeEndDate && (
                                <Col xs={24} md={12}>
                                    <Form.Item name="end_date" label="End Date">
                                        <DatePicker
                                            format="YYYY-MM-DD"
                                            style={{ width: '100%' }}
                                            placeholder="Select end date"
                                            onChange={(e, dateString) => setEndDate(dateString)}
                                        />
                                    </Form.Item>
                                </Col>
                            )}

                            <Col xs={24} md={12}>
                                <Form.Item name="resign_date" label="Resign Date">
                                    <DatePicker
                                        format="YYYY-MM-DD"
                                        style={{ width: '100%' }}
                                        placeholder="Select resign date"
                                        onChange={(e, dateString) => setResignDate(dateString)}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="branch_name" label="Branch">
                                    <Input placeholder="Enter branch name" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="grade" label="Grade">
                                    <Select placeholder="Choose grade">
                                        <Option value="1">1</Option>
                                        <Option value="2">2</Option>
                                        <Option value="3">3</Option>
                                        <Option value="4">4</Option>
                                        <Option value="5">5</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="class" label="Class">
                                    <Select placeholder="Choose class">
                                        <Option value="A">A</Option>
                                        <Option value="B">B</Option>
                                        <Option value="C">C</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    {currentStep === 2 && (
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item name="gender" label="Gender">
                                    <Select placeholder="Choose gender">
                                        <Option value="Male">Male</Option>
                                        <Option value="Female">Female</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="religion" label="Religion">
                                    <Select placeholder="Choose religion">
                                        <Option value="Islam">Islam</Option>
                                        <Option value="Kristen">Kristen</Option>
                                        <Option value="Katolik">Katolik</Option>
                                        <Option value="Hindu">Hindu</Option>
                                        <Option value="Budha">Budha</Option>
                                        <Option value="Konghucu">Konghucu</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="marital_status" label="Marital Status">
                                    <Select placeholder="Choose marital status">
                                        <Option value="Married">Married</Option>
                                        <Option value="Single">Single</Option>
                                        <Option value="Widow">Widow</Option>
                                        <Option value="Widower">Widower</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="birthdate" label="Date of Birth">
                                    <DatePicker
                                        format="YYYY-MM-DD"
                                        style={{ width: '100%' }}
                                        placeholder="Select date of birth"
                                        onChange={(e, dateString) => setBirthDateStr(dateString)}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="bloody_type" label="Blood Type">
                                    <Select placeholder="Choose blood type">
                                        <Option value="A">A</Option>
                                        <Option value="B">B</Option>
                                        <Option value="AB">AB</Option>
                                        <Option value="O">O</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item name="address" label="KTP Address">
                                    <Input.TextArea rows={2} placeholder="Enter KTP address" />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item name="address_now" label="Current Address">
                                    <Input.TextArea rows={2} placeholder="Enter current address" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="postal_code" label="Postal Code">
                                    <Input placeholder="Enter postal code" />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    {currentStep === 3 && (
                        <Form.List name="education_history">
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ key, name, ...restField }, index) => (
                                        <Card
                                            key={key}
                                            size="small"
                                            title={`Education ${index + 1}`}
                                            style={{ marginBottom: 16 }}
                                            extra={
                                                <Button
                                                    type="text"
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => remove(name)}
                                                >
                                                    Remove
                                                </Button>
                                            }
                                        >
                                            <Row gutter={16}>
                                                <Col xs={24} md={8}>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'education_level']}
                                                        label="Education Level"
                                                    >
                                                        <Select allowClear placeholder="Choose level">
                                                            <Option value="Elementary School">Elementary School</Option>
                                                            <Option value="Junior High School">Junior High School</Option>
                                                            <Option value="Senior High School">Senior High School</Option>
                                                            <Option value="Diploma">Diploma</Option>
                                                            <Option value="Bachelor">Bachelor</Option>
                                                            <Option value="Master">Master</Option>
                                                            <Option value="Doctorate">Doctorate</Option>
                                                            <Option value="Other">Other</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={16}>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'institution_name']}
                                                        label="Institution Name"
                                                        rules={[{ required: true, message: 'Institution name is required.' }]}
                                                    >
                                                        <Input placeholder="Enter school or university name" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item {...restField} name={[name, 'major']} label="Major">
                                                        <Input placeholder="Enter major" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    <Form.Item {...restField} name={[name, 'start_year']} label="Start Year">
                                                        <Input type="number" min={1900} max={2100} placeholder="YYYY" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'end_year']}
                                                        label="End Year"
                                                        dependencies={[[name, 'start_year']]}
                                                        rules={[
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    const startYear = getFieldValue(['education_history', name, 'start_year']);
                                                                    if (!value || !startYear || Number(value) >= Number(startYear)) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(new Error('End year cannot be earlier than start year.'));
                                                                },
                                                            }),
                                                        ]}
                                                    >
                                                        <Input type="number" min={1900} max={2100} placeholder="YYYY" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={8}>
                                                    <Form.Item {...restField} name={[name, 'gpa']} label="GPA / Score">
                                                        <Input placeholder="Example: 3.75" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={16}>
                                                    <Form.Item {...restField} name={[name, 'description']} label="Description">
                                                        <Input.TextArea rows={2} placeholder="Optional notes" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}

                                    <Button type="dashed" block icon={<PlusOutlined />} onClick={() => add()}>
                                        Add Education History
                                    </Button>
                                </>
                            )}
                        </Form.List>
                    )}

                    {currentStep === 4 && (
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item name="ptkp_status" label="PTKP">
                                    <Select placeholder="Choose PTKP status">
                                        <Option value="TK/0">TK/0</Option>
                                        <Option value="TK/1">TK/1</Option>
                                        <Option value="TK/2">TK/2</Option>
                                        <Option value="TK/3">TK/3</Option>
                                        <Option value="K/0">K/0</Option>
                                        <Option value="K/1">K/1</Option>
                                        <Option value="K/2">K/2</Option>
                                        <Option value="K/3">K/3</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="npwp" label="NPWP">
                                    <Input placeholder="Enter NPWP number" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="bank_name" label="Bank Name">
                                    <Input placeholder="Enter bank name" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="bank_account" label="No. Account">
                                    <Input placeholder="Enter bank account number" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="bank_account_name" label="On Account Name">
                                    <Input placeholder="Enter account holder name" />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}
                </Form>
            </Modal>

            <Modal
                title={activationData && isEmployeeActive(activationData) ? "Deactivate Employee" : "Activate Employee"}
                open={isActivationModalOpen}
                onCancel={() => {
                    setIsActivationModalOpen(false);
                    setActivationData(null);
                    setActivationReason('');
                }}
                onOk={submitActivation}
                okText={activationData && isEmployeeActive(activationData) ? "Deactivate" : "Activate"}
                okButtonProps={{
                    danger: activationData && isEmployeeActive(activationData)
                }}
                confirmLoading={loading}
            >
                {activationData && (
                    <>
                        <Descriptions bordered column={1} size="small" style={{ marginBottom: 16 }}>
                            <Descriptions.Item label="Employee">
                                {activationData.name}
                            </Descriptions.Item>

                            <Descriptions.Item label="Current Status">
                                {isEmployeeActive(activationData) ? (
                                    <Tag color="green">Active</Tag>
                                ) : (
                                    <Tag color="red">Inactive</Tag>
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="Resign Date">
                                {formatDate(activationData.resign_date)}
                            </Descriptions.Item>

                            <Descriptions.Item label="End Date">
                                {formatDate(activationData.end_date)}
                            </Descriptions.Item>
                        </Descriptions>

                        <Form layout="vertical">
                            <Form.Item label="Reason" required>
                                <Input.TextArea
                                    rows={4}
                                    value={activationReason}
                                    onChange={(e) => setActivationReason(e.target.value)}
                                    placeholder={
                                        isEmployeeActive(activationData)
                                            ? "Input reason for deactivation"
                                            : "Input reason for activation"
                                    }
                                />
                            </Form.Item>
                        </Form>
                    </>
                )}
            </Modal>
        </div>
    );
}


export default Employee;